export const PAGE_PATHS = {
  PET_DETAIL: "/pet-detail",
  CATS: "/cats",
  DOGS: "/dogs",
  CRITTERS: "/critters",
  ALL_CATS: "/all-cats",
  ALL_DOGS: "/all-dogs",
  ALL_CRITTERS: "/all-critters",
  ADOPTED: "/adoption/recently-adopted",
  ALL_ADOPTED: "/recently-adopted",
  FIND_A_PET: "/find-a-pet",
  ALL_HOMEPAGE: "/home",
};
